import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {
  Firestore,
  filterUndefined,
  multiUndeleted,
  type WithRef,
  where,
} from '@principle-theorem/shared';
import {
  CurrentScopeFacade,
  OrganisationService,
  StateBasedNavigationService,
} from '@principle-theorem/ng-principle-shared';
import { BaseResolver } from '@principle-theorem/ng-shared';
import { type IBrand } from '@principle-theorem/principle-core/interfaces';
import { first } from 'lodash';
import { from, type Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class BrandResolverService extends BaseResolver<
  WithRef<IBrand> | undefined
> {
  constructor(
    protected _router: Router,
    private _organisation: OrganisationService,
    private _stateNav: StateBasedNavigationService,
    private _currentScopeFacade: CurrentScopeFacade
  ) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<WithRef<IBrand> | undefined> {
    const slug: string = route.paramMap.get('brand-slug') || '';

    return this._organisation.brandCol$.pipe(
      filterUndefined(),
      switchMap((brandCol) =>
        Firestore.query$(brandCol, where('slug', '==', slug)).pipe(
          multiUndeleted(),
          map(first)
        )
      ),
      switchMap((foundBrand) => {
        if (!foundBrand) {
          return from(this._stateNav.organisation()).pipe(map(() => undefined));
        }
        this._currentScopeFacade.setBrandFromResolver(foundBrand);
        return of(foundBrand);
      }),
      take(1)
    );
  }
}
